export default __webpack_public_path__ + "static/media/dataanalytics.43a8baa3.svg";